var React = require('react');

function EditProfileIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.5 0A4.5 4.5 0 0 0 0 4.5v15A4.5 4.5 0 0 0 4.5 24H12v-1.5H4.5a3 3 0 0 1-3-3v-15a3 3 0 0 1 3-3h15a3 3 0 0 1 3 3V12H24V4.5A4.5 4.5 0 0 0 19.5 0h-15zm6.622 18.75H12v-1.5h-.878a2.251 2.251 0 0 0-4.244 0H5.25a.75.75 0 0 0 0 1.5h1.628a2.25 2.25 0 0 0 4.244 0zM4.5 6a.75.75 0 0 1 .75-.75h1.628a2.25 2.25 0 0 1 4.244 0h7.628a.75.75 0 0 1 0 1.5h-7.628a2.251 2.251 0 0 1-4.244 0H5.25A.75.75 0 0 1 4.5 6zm.75 5.25a.75.75 0 0 0 0 1.5h4.628a2.25 2.25 0 0 0 4.244 0h4.628a.75.75 0 0 0 0-1.5h-4.628a2.251 2.251 0 0 0-4.244 0H5.25zm15.172 3.364L14 21.156V24h2.964l6.422-6.422a2.096 2.096 0 1 0-2.964-2.964z","fill":"#fff"}));
}

EditProfileIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = EditProfileIcon;

EditProfileIcon.default = EditProfileIcon;
